import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { MatTableModule, MatPaginatorModule, MatSortModule, MatIconModule, MatButtonModule, MatSelectModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatRadioModule, MAT_CHECKBOX_CLICK_ACTION, MatCheckboxModule } from '@angular/material';
import { ManagepayoutsComponent } from './managepayouts.component';
import { ManagePayOutsRoutingModule } from './managepayouts-routing.module';
import { ManagecreditpopupComponent } from '../managecreditpopup/managecreditpopup.component';



@NgModule({
  declarations: [ManagepayoutsComponent],
  imports: [
      CommonModule,
      NgbModule,
      ManagePayOutsRoutingModule,
      CommonModule,
      OwlDateTimeModule,
      OwlNativeDateTimeModule,
      SharedModule,
      ReactiveFormsModule,
      MatchHeightModule,
      MatTableModule,
      MatPaginatorModule,
      MatSortModule,
      MatIconModule,
      MatButtonModule,
      MatchHeightModule,
      MatSelectModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule,
      FormsModule,
      MatDialogModule,
      MatCheckboxModule,
  ],
  // entryComponents:[ManagecreditpopupComponent]
  providers: [MatRadioModule,
    {provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'check'}
  ]
})
export class ManagepayoutsModule { }



